// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `

.chatroom {
    height : 100%;
    width : 100%
  }
  
  .chatroom-title {
    display : flex;
    justify-content: space-around;
    border-bottom: 1px solid #ccc;
    font-size: smaller;

    height : 40px;
  }

 .chatroom-footer {
    display : flex;
    justify-content: space-around;
    border-top: 1px solid #ccc;
    height : 40px;
  }


  .chat-input {
    display: flex;
    padding: 1px;
    border-top: 1px solid #ccc;
  }
  
  .chat-input input {
    flex: 1 1;
    padding: 2px;
    border: 1px solid #ccc;
    border-radius: 4px;
    margin-right: 10px;
  }

  .chat-input-textarea {
    flex: '1' 1;
    margin: 1px;
    font-size: 16px; /* ou plus, no zoom */
    width : 90%;
    height : 50px;
    border-radius: 10px;
    resize: 'none';
    overflow: 'hidden';
    color : #11282d;
    background : #eee8b6; 
  }

  .chat-input button {
    margin: 5px;
    padding: 10px 20px;
    border: none;
    color: #395e65;
    background: #fff066;
    border-radius: 4px;
    cursor: pointer;
  }
  
.imagedButton {
    touch-action : manipulation;
    -webkit-touch-callout : none;
    -webkit-user-select: none;
    user-select: none;
    border-radius: 3px;
}

.chat-messages {
    display : flex;
    flex-direction: column;
    border-radius: 20px;
    background-color: #395e65;
    height: 70%;
    border: '1px solid black';
    padding: 5px;
    overflow-y: auto;
  }
  #chat-messages-end {
    height: 0.1%;
    opacity: 0;
  }

  .message {
    border-radius: 7px;
    text-align: left;
    margin: 5px 0;
    max-width: 95%;
    background : #395e65;
    color : #fff066;;
    border-color : #fff066;;
    border-width: 0.01px; /* this allows you to adjust the thickness */
    border-style: solid;
  }
  
  .message.self {
    text-align: left;
    margin-left: auto;
    max-width: 95%;
    color : #395e65;
    background : #efe056;  }
    
  .message.self.corrected {
    text-align: left;
    margin-left: auto;
    max-width: 95%;
    color : #395e65;
    background : hsl(48, 90%, 51%);  }
  
    .message.corrected {
    text-align: left;
    margin-left: auto;
    max-width: 85%;
    background : #395e65;
    color : hsl(48, 90%, 51%);  }
  
   
  .message-content {
    padding: 1px;
    border-radius: 4px;
    width : 100%;
  }
  
  .message-user {
    font-weight: bold;
    font-size: smaller;
    background : #395e65;
    color : #dfd046;
    border-radius: 2px;
    text-align: center;
    width : 20%;
    margin : 4px;
 }


 .negative {
  background : rgb(130, 105, 141)
  ;
}

 .message-speaker{
  font-weight: bold;
  font-size: xx-small;
  border-radius: 2px;
  text-align: right;
  width : 20%;
  padding : 4px;
}

.message-date {
  cursor: pointer;
  font-weight: bold;
  font-size: xx-small;
  color : #395e65;
  background : #dfd046;
  border-radius: 5px;
  text-align: center;
  width : 10%;
  padding : 1px;
}

.message-date.current_target {
  border: 3px solid rgb(131, 5, 153);
  background-color: whitesmoke;
  color : rgb(9, 0, 22);
  font-size : small;
}
.message-content.current_target/.message-date {
  background : whitesmoke;
  color : rgb(9, 0, 22);
  font-size : small;
}

.message-domain {
  font-weight: bold;
  font-size: small;
   color : #395e65;
   background : #dfd046;
  border-radius: 8px;
  text-align: center;
}

.message .message-domain {
  background : #dfd046;
  color : #395e65; 
}

.message .message-domain.corrected {
  background : orange;
  color : #395e65; 
}

.message .message-domain.corrected.negative {
  background : orange;
  color : #870505; 
}

.message.self .message-domain{
  background : #395e65;
  color : #dfd046; 
}

.message.self .message-domain.corrected{
  background : #395e65;
  color : orange; 
}


.message.self .message-domain.corrected.negative{
  background : #870505;
  color : orange; 
}


 .message-line {
    text-align: center;
    margin-block-start: 0.2px;
    margin-block-end: 0.2px;
    font-weight: bold;
    font-size: small;
    padding : 10px;
 }

 .users {
  display : flex;
  height : 3.9%;
  justify-content: space-around;
  font-size: xx-small;
  text-shadow: 
        -0.5px -0.5px 0 #000,
         0.5px -0.5px 0 #000,
        -0.5px  0.5px 0 #000,
         0.5px  0.5px 0 #000;
 }

  .user::before {
  content: "🔊";
  margin-right: 3px;
  border : 1px;
}
 .user::after {
  content: "🎤";
  margin-left: 3px;
}


.phone_on::before { background-color: rgb(85, 255, 85); }
.phone_on::after { background-color: rgb(85, 255, 85); }
.phone_off::before { background-color: rgb(255, 85, 85); }
.phone_off::after { background-color: rgb(255, 85, 85); }
.mic_off::before { background-color: rgb(85, 255, 85); }
.mic_off::after { background-color: rgb(255, 85, 85); }

.speakingOnPhone {color : #dfd046;
                  font-size : xx-small;
                  min-width: 10ch;
                }
`, "",{"version":3,"sources":["webpack://./src/components/ChatRoom.css"],"names":[],"mappings":";;AAEA;IACI,aAAa;IACb;EACF;;EAEA;IACE,cAAc;IACd,6BAA6B;IAC7B,6BAA6B;IAC7B,kBAAkB;;IAElB,aAAa;EACf;;CAED;IACG,cAAc;IACd,6BAA6B;IAC7B,0BAA0B;IAC1B,aAAa;EACf;;;EAGA;IACE,aAAa;IACb,YAAY;IACZ,0BAA0B;EAC5B;;EAEA;IACE,SAAO;IACP,YAAY;IACZ,sBAAsB;IACtB,kBAAkB;IAClB,kBAAkB;EACpB;;EAEA;IACE,WAAS;IACT,WAAW;IACX,eAAe,EAAE,qBAAqB;IACtC,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,cAAc;IACd,kBAAkB;IAClB,eAAe;IACf,oBAAoB;EACtB;;EAEA;IACE,WAAW;IACX,kBAAkB;IAClB,YAAY;IACZ,cAAc;IACd,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;EACjB;;AAEF;IACI,2BAA2B;IAC3B,4BAA4B;IAC5B,yBAAyB;IACzB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,sBAAsB;IAItB,mBAAmB;IACnB,yBAAyB;IACzB,WAAW;IACX,yBAAyB;IACzB,YAAY;IACZ,gBAAgB;EAClB;EACA;IACE,YAAY;IACZ,UAAU;EACZ;;EAEA;IAIE,kBAAkB;IAClB,gBAAgB;IAChB,aAAa;IACb,cAAc;IACd,oBAAoB;IACpB,eAAe;IACf,sBAAsB;IACtB,oBAAoB,EAAE,4CAA4C;IAClE,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;IAChB,iBAAiB;IACjB,cAAc;IACd,eAAe;IACf,oBAAoB,GAAG;;EAEzB;IACE,gBAAgB;IAChB,iBAAiB;IACjB,cAAc;IACd,eAAe;IACf,8BAA8B,GAAG;;IAEjC;IACA,gBAAgB;IAChB,iBAAiB;IACjB,cAAc;IACd,oBAAoB;IACpB,yBAAyB,GAAG;;;EAG9B;IACE,YAAY;IACZ,kBAAkB;IAClB,YAAY;EACd;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;IAClB,oBAAoB;IACpB,eAAe;IAIf,kBAAkB;IAClB,kBAAkB;IAClB,WAAW;IACX,YAAY;CACf;;;CAGA;EACC;EACA;AACF;;CAEC;EACC,iBAAiB;EACjB,mBAAmB;EAInB,kBAAkB;EAClB,iBAAiB;EACjB,WAAW;EACX,aAAa;AACf;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,oBAAoB;EAIpB,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;EACX,aAAa;AACf;;AAEA;EACE,kCAAkC;EAClC,4BAA4B;EAC5B,qBAAqB;EACrB,iBAAiB;AACnB;AACA;EACE,uBAAuB;EACvB,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;GACf,eAAe;GACf,oBAAoB;EAGrB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,cAAc;AAChB;;;AAGA;EACE,oBAAoB;EACpB,cAAc;AAChB;;;CAGC;IACG,kBAAkB;IAClB,yBAAyB;IACzB,uBAAuB;IACvB,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;CACjB;;CAEA;EACC,cAAc;EACd,aAAa;EACb,6BAA6B;EAC7B,mBAAmB;EACnB;;;;4BAI0B;CAC3B;;EAEC;EACA,aAAa;EACb,iBAAiB;EACjB,YAAY;AACd;CACC;EACC,aAAa;EACb,gBAAgB;AAClB;;;AAGA,oBAAoB,kCAAkC,EAAE;AACxD,mBAAmB,kCAAkC,EAAE;AACvD,qBAAqB,kCAAkC,EAAE;AACzD,oBAAoB,kCAAkC,EAAE;AACxD,mBAAmB,kCAAkC,EAAE;AACvD,kBAAkB,kCAAkC,EAAE;;AAEtD,kBAAkB,eAAe;kBACf,oBAAoB;kBACpB,eAAe;gBACjB","sourcesContent":["\r\n\r\n.chatroom {\r\n    height : 100%;\r\n    width : 100%\r\n  }\r\n  \r\n  .chatroom-title {\r\n    display : flex;\r\n    justify-content: space-around;\r\n    border-bottom: 1px solid #ccc;\r\n    font-size: smaller;\r\n\r\n    height : 40px;\r\n  }\r\n\r\n .chatroom-footer {\r\n    display : flex;\r\n    justify-content: space-around;\r\n    border-top: 1px solid #ccc;\r\n    height : 40px;\r\n  }\r\n\r\n\r\n  .chat-input {\r\n    display: flex;\r\n    padding: 1px;\r\n    border-top: 1px solid #ccc;\r\n  }\r\n  \r\n  .chat-input input {\r\n    flex: 1;\r\n    padding: 2px;\r\n    border: 1px solid #ccc;\r\n    border-radius: 4px;\r\n    margin-right: 10px;\r\n  }\r\n\r\n  .chat-input-textarea {\r\n    flex: '1';\r\n    margin: 1px;\r\n    font-size: 16px; /* ou plus, no zoom */\r\n    width : 90%;\r\n    height : 50px;\r\n    border-radius: 10px;\r\n    resize: 'none';\r\n    overflow: 'hidden';\r\n    color : #11282d;\r\n    background : #eee8b6; \r\n  }\r\n\r\n  .chat-input button {\r\n    margin: 5px;\r\n    padding: 10px 20px;\r\n    border: none;\r\n    color: #395e65;\r\n    background: #fff066;\r\n    border-radius: 4px;\r\n    cursor: pointer;\r\n  }\r\n  \r\n.imagedButton {\r\n    touch-action : manipulation;\r\n    -webkit-touch-callout : none;\r\n    -webkit-user-select: none;\r\n    user-select: none;\r\n    border-radius: 3px;\r\n}\r\n\r\n.chat-messages {\r\n    display : flex;\r\n    flex-direction: column;\r\n    -moz-border-radius: 20px;\r\n    -webkit-border-radius: 20px;\r\n    -khtml-border-radius: 20px;\r\n    border-radius: 20px;\r\n    background-color: #395e65;\r\n    height: 70%;\r\n    border: '1px solid black';\r\n    padding: 5px;\r\n    overflow-y: auto;\r\n  }\r\n  #chat-messages-end {\r\n    height: 0.1%;\r\n    opacity: 0;\r\n  }\r\n\r\n  .message {\r\n    -moz-border-radius: 7px;\r\n    -webkit-border-radius: 7px;\r\n    -khtml-border-radius: 7px;\r\n    border-radius: 7px;\r\n    text-align: left;\r\n    margin: 5px 0;\r\n    max-width: 95%;\r\n    background : #395e65;\r\n    color : #fff066;;\r\n    border-color : #fff066;;\r\n    border-width: 0.01px; /* this allows you to adjust the thickness */\r\n    border-style: solid;\r\n  }\r\n  \r\n  .message.self {\r\n    text-align: left;\r\n    margin-left: auto;\r\n    max-width: 95%;\r\n    color : #395e65;\r\n    background : #efe056;  }\r\n    \r\n  .message.self.corrected {\r\n    text-align: left;\r\n    margin-left: auto;\r\n    max-width: 95%;\r\n    color : #395e65;\r\n    background : hsl(48, 90%, 51%);  }\r\n  \r\n    .message.corrected {\r\n    text-align: left;\r\n    margin-left: auto;\r\n    max-width: 85%;\r\n    background : #395e65;\r\n    color : hsl(48, 90%, 51%);  }\r\n  \r\n   \r\n  .message-content {\r\n    padding: 1px;\r\n    border-radius: 4px;\r\n    width : 100%;\r\n  }\r\n  \r\n  .message-user {\r\n    font-weight: bold;\r\n    font-size: smaller;\r\n    background : #395e65;\r\n    color : #dfd046; \r\n    -moz-border-radius: 2px;\r\n    -webkit-border-radius: 2px;\r\n    -khtml-border-radius: 2px;\r\n    border-radius: 2px;\r\n    text-align: center;\r\n    width : 20%;\r\n    margin : 4px;\r\n }\r\n\r\n\r\n .negative {\r\n  background : rgb(130, 105, 141)\r\n  ;\r\n}\r\n\r\n .message-speaker{\r\n  font-weight: bold;\r\n  font-size: xx-small;\r\n  -moz-border-radius: 2px;\r\n  -webkit-border-radius: 2px;\r\n  -khtml-border-radius: 2px;\r\n  border-radius: 2px;\r\n  text-align: right;\r\n  width : 20%;\r\n  padding : 4px;\r\n}\r\n\r\n.message-date {\r\n  cursor: pointer;\r\n  font-weight: bold;\r\n  font-size: xx-small;\r\n  color : #395e65;\r\n  background : #dfd046; \r\n  -moz-border-radius: 1px;\r\n  -webkit-border-radius: 1px;\r\n  -khtml-border-radius: 1px;\r\n  border-radius: 5px;\r\n  text-align: center;\r\n  width : 10%;\r\n  padding : 1px;\r\n}\r\n\r\n.message-date.current_target {\r\n  border: 3px solid rgb(131, 5, 153);\r\n  background-color: whitesmoke;\r\n  color : rgb(9, 0, 22);\r\n  font-size : small;\r\n}\r\n.message-content.current_target/.message-date {\r\n  background : whitesmoke;\r\n  color : rgb(9, 0, 22);\r\n  font-size : small;\r\n}\r\n\r\n.message-domain {\r\n  font-weight: bold;\r\n  font-size: small;\r\n   color : #395e65;\r\n   background : #dfd046; \r\n  -moz-border-radius: 8px;\r\n  -webkit-border-radius: 8px;\r\n  border-radius: 8px;\r\n  text-align: center;\r\n}\r\n\r\n.message .message-domain {\r\n  background : #dfd046;\r\n  color : #395e65; \r\n}\r\n\r\n.message .message-domain.corrected {\r\n  background : orange;\r\n  color : #395e65; \r\n}\r\n\r\n.message .message-domain.corrected.negative {\r\n  background : orange;\r\n  color : #870505; \r\n}\r\n\r\n.message.self .message-domain{\r\n  background : #395e65;\r\n  color : #dfd046; \r\n}\r\n\r\n.message.self .message-domain.corrected{\r\n  background : #395e65;\r\n  color : orange; \r\n}\r\n\r\n\r\n.message.self .message-domain.corrected.negative{\r\n  background : #870505;\r\n  color : orange; \r\n}\r\n\r\n\r\n .message-line {\r\n    text-align: center;\r\n    margin-block-start: 0.2px;\r\n    margin-block-end: 0.2px;\r\n    font-weight: bold;\r\n    font-size: small;\r\n    padding : 10px;\r\n }\r\n\r\n .users {\r\n  display : flex;\r\n  height : 3.9%;\r\n  justify-content: space-around;\r\n  font-size: xx-small;\r\n  text-shadow: \r\n        -0.5px -0.5px 0 #000,\r\n         0.5px -0.5px 0 #000,\r\n        -0.5px  0.5px 0 #000,\r\n         0.5px  0.5px 0 #000;\r\n }\r\n\r\n  .user::before {\r\n  content: \"🔊\";\r\n  margin-right: 3px;\r\n  border : 1px;\r\n}\r\n .user::after {\r\n  content: \"🎤\";\r\n  margin-left: 3px;\r\n}\r\n\r\n\r\n.phone_on::before { background-color: rgb(85, 255, 85); }\r\n.phone_on::after { background-color: rgb(85, 255, 85); }\r\n.phone_off::before { background-color: rgb(255, 85, 85); }\r\n.phone_off::after { background-color: rgb(255, 85, 85); }\r\n.mic_off::before { background-color: rgb(85, 255, 85); }\r\n.mic_off::after { background-color: rgb(255, 85, 85); }\r\n\r\n.speakingOnPhone {color : #dfd046;\r\n                  font-size : xx-small;\r\n                  min-width: 10ch;\r\n                }\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
